import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { Image } from "expo-image";
import React, { useImperativeHandle } from "react";

interface ImagePreviewRef {
  show: (url: string) => void;
}
const ImagePreviewModal = React.forwardRef<ImagePreviewRef, {}>((_, ref) => {
  const [show, setShow] = React.useState(false);
  const [url, setUrl] = React.useState("");

  useImperativeHandle(ref, () => ({
    show: (url: string) => {
      setUrl(url);
      setShow(true);
    },
  }));

  return (
    <ReusableModal
      isVisible={show}
      onClose={() => setShow(false)}
      className="w-full h-full"
      fullScreen
    >
      <Image
        source={{ uri: url }}
        className="w-full flex-1"
        contentFit="contain"
        contentPosition={"center"}
      />
    </ReusableModal>
  );
});

ImagePreviewModal.displayName = "ImagePreviewModal";
export { ImagePreviewModal };
